export const paymentApiUrl = process.env.REACT_APP_PAYMENT_API_URL || "";
export const orderApiUrl = process.env.REACT_APP_ORDER_API_URL || "";
export const merchantApiUrl = process.env.REACT_APP_MERCHANT_API_URL || "";
export const paytrailApiUrl = "https://services.paytrail.com";
